const __viteBrowserExternal = {};

export { __viteBrowserExternal as default };
//# sourceMappingURL=__vite-browser-external.js.map
